export const GLOBAL_URL = `${process.env.REACT_APP_BASE_URL}/api/`;

// export const REGULAR_EXPRESSION =  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]{8,}$/g;

// export const REGULAR_EXPRESSION =  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&()_+|}{":>?</.,;'[\]=\\#^\-])[A-Za-z\d@$!%*?&()_+|}{":>?</.,;'[\]=\\#^\-]{8,}$/g;

// export const REGULAR_EXPRESSION = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&()_+|}{":>?<.,;'[\]=\\#^\\-])[A-Za-z\d@$!%*?&()_+|}{":>?<.,;'[\]=\\#^\\-]{8,}$/g;

// export const CAPTCHA_KEY_CLIENT_SIDE = "6LeIBwkqAAAAAIkBASU2KnmOV485O7OvHlIIKy_L";
export const CAPTCHA_KEY_CLIENT_SIDE =
  "6Lc5sgsqAAAAAKSyqknqqfaIwRdBxgwRsSe2NEpG";

export const REGULAR_EXPRESSION = new RegExp(
  "^(?=.*[A-Za-z])" +
    "(?=.*\\d)" +
    "(?=.*[@$!%*?&()_+|}{\":>?</.,;'[\\]=\\\\#^\\-])" +
    ".{8,}$"
);
export const IP_URL = `${GLOBAL_URL}ip/`;
export const DD_URL = `${GLOBAL_URL}dd/`;
// export const DD_URL = `${GLOBAL_URL}dd/`;
export const postRequestGlobal = async (endpoint, data) => {
  const response = await fetch(`${GLOBAL_URL}${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const returndata = await response.json();
  return returndata;
};

export const getRequestGlobal = async (endpoint, data) => {
  let url = `${IP_URL}${endpoint}`;
  const params = new URLSearchParams(data);
  if (params) {
    url += `?${params}`;
  }
  const response = await fetch(url, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const returndata = await response.json();
  return returndata;
};

export const patchRequestGlobal = async () => {};

export const deleteRequestGlobal = async () => {};
